<template>
  <v-expansion-panel-content
    :value="open"
    :hide-actions="hideActions"
    :expand-icon="`bexsicon-${
      open ? 'minus' : 'plus'
    } expansion-icon-size ${iconClassModifier}`"
  >
    <div slot="header">
      <slot name="header"></slot>
    </div>
    <div class="content">
      <slot name="content"></slot>
    </div>
  </v-expansion-panel-content>
</template>

<script>
export default {
  props: {
    hideActions: Boolean,
    iconClassModifier: String,
  },
  data() {
    return {
      open: true,
    };
  },
};
</script>



// WEBPACK FOOTER //
// ./src/components/layout/ExpansionPanel.vue